export default {
  GET_USER_ACTIVITIES: "GET_USER_ACTIVITIES",
  NEW_USER_ACTIVITY: "NEW_USER_ACTIVITY",
  MARK_AS_SEEN: "MARK_AS_SEEN",
  SAVE_EVIDENCE: "SAVE_EVIDENCE"
};
